<template>
    <AppButton :desired-action="desiredAction" element="button" type="submit" :disabled="processing || disabled">
        <IconFilterFilled class="-ml-0.5 mr-2 w-4 h-4" v-if="isFilter" />
        {{ buttonText }}
        <span v-if="processing" class="ml-1 btn-spinner" />
    </AppButton>
</template>
<script>
export default {
    name: 'SubmitFormButton',
};
</script>
<script setup>
import AppButton from '@/components/AppButton.vue';
import { IconFilterFilled } from '@tabler/icons-vue';

defineProps({
    processing: { required: true },
    disabled: { required: false, default: false },
    buttonText: { required: true },
    isFilter: { type: Boolean, default: false, required: false },
    desiredAction: {
        type: [Boolean, String],
        default: true,
    },
});
</script>
